<template>
  <footer class="footer">
    <div class="container">

      <div class="columns is-variable is-1-mobile is-8-desktop">
        <section class="column">
          <h3 class="subtitle">聯絡我們</h3>
          <form method="post" action="https://formspree.io/nthuaagc@gmail.com">

            <b-field grouped>
              <b-input name="name" placeholder="名字" icon-pack="fas" icon="user" expanded></b-input>
              <b-input name="_replyto" type="email" placeholder="E-mail" icon-pack="fas" icon="envelope" expanded></b-input>
            </b-field>

            <b-field>
                <b-input name="message" type="textarea" placeholder="訊息內容"></b-input>
            </b-field>

            <b-field grouped>
                <div class="control">
                  <button class="button is-dark" type="submit" value="Send">傳送</button>
                </div>
                <div class="control">
                  <button class="button is-text" type="reset" value="重新填寫" onclick="return confirm('確認清除?')" >重新填寫</button>
                </div>
            </b-field>
          </form>
        </section>
        <section class="column">
          <h3 class="subtitle">社群</h3>
          <p>誠摯邀請您加入我們的行列，如有任何問題，請利用表格或造訪社群連結與我們聯繫！</p><br/>
          <p class="buttons">
            <a class="button is-large" href="https://www.facebook.com/groups/1463346633993795/">
              <b-icon
                  pack="fab"
                  icon="facebook-f">
              </b-icon>
            </a>
            <a class="button is-large" href="https://www.linkedin.com/groups/12055145/">
              <b-icon
                  pack="fab"
                  icon="linkedin">
              </b-icon>
            </a>
          </p>
        </section>
      </div><p class="has-text-centered has-text-grey-light is-size-7-mobile">
        &copy; Copyright {{ new Date().getFullYear() }} NTHUAAGC. All Rights Reserved.
      </p>

    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
};
</script>

<style lang="scss" scoped>
.footer {
  background-image: url("../assets/overlay2.png"), url("../assets/overlay3.svg"), linear-gradient(45deg, #ffe9d3, #ffe7da);
  background-size: auto, cover, cover;
  padding: 3rem 1.5rem 4rem;
}
</style>
